var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order__comments__empty_state my-lg"},[_c('div',{staticClass:"order__comments__empty_state--img"},[(_vm.iconUrl)?_c('img',{attrs:{"src":_vm.iconUrl,"alt":_vm.iconAlt}}):_vm._e()]),_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('span',[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }